export default {"src":"/_next/static/media/fossil_logo.21ed0e96.svg","height":26,"width":132};